import { Link } from 'react-router-dom';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { Settings, Users, Building, Tag, Wrench, AlertCircle, FileText } from 'lucide-react';

export default function Administration(): React.ReactElement {
  const adminSections = [
    {
      title: 'Locations',
      description: 'Configure asset locations and departments',
      icon: Building,
      href: '/settings/locations',
    },
    {
      title: 'Categories',
      description: 'Manage asset categories and depreciation defaults',
      icon: Tag,
      href: '/settings/categories',
    },
    {
      title: 'Equipment',
      description: 'Manage equipment records and supplier information',
      icon: Wrench,
      href: '/settings/equipment',
    },
    {
      title: 'Leases',
      description: 'Manage lease agreements and track commitments',
      icon: FileText,
      href: '/administration/leases',
    },
    {
      title: 'Disposal Reasons',
      description: 'Manage reasons for asset disposal',
      icon: AlertCircle,
      href: '/settings/disposal-reasons',
    },
    {
      title: 'Asset Options',
      description: 'Configure default settings and behaviors',
      icon: Settings,
      href: '/settings/asset-options',
    },
  ];

  return (
    <div className="flex h-full flex-col">
      {/* Header */}
      <div className="border-b bg-card p-6">
        <div className="flex items-center gap-2">
          <Settings className="h-6 w-6 text-primary" />
          <h1 className="text-2xl font-bold tracking-tight">Administration</h1>
        </div>
        <p className="text-sm text-muted-foreground mt-1">
          Central hub for system configuration and administrative tasks
        </p>
      </div>

      {/* Content */}
      <div className="flex-1 overflow-auto p-6">

        <div className="grid gap-4 md:grid-cols-2 lg:grid-cols-3">
          {adminSections.map((section) => {
            const Icon = section.icon;
            return (
              <Link
                key={section.title}
                to={section.href}
                className="block"
              >
                <Card className="cursor-pointer transition-all hover:shadow-lg h-full">
                  <CardHeader>
                    <div className="flex items-center gap-3">
                      <div className="flex h-10 w-10 items-center justify-center rounded-lg bg-primary/10">
                        <Icon className="h-5 w-5 text-primary" />
                      </div>
                      <CardTitle className="text-lg">{section.title}</CardTitle>
                    </div>
                  </CardHeader>
                  <CardContent>
                    <CardDescription>{section.description}</CardDescription>
                  </CardContent>
                </Card>
              </Link>
            );
          })}
        </div>
      </div>
    </div>
  );
}
